import SideBarSection from './SideBarSection';
import TextFieldLabel from '../../Input/TextFieldLabel';
import Button from '../../Buttons/Button';

const ReviewButton = ({ review, label, disabled, performReview, overrideReview, fullWidth }) => {
	//console.log("### ReviewButton review:", review);
	return (
		<SideBarSection separator>
			{label &&<TextFieldLabel label={label} />}
			<Button
				noHover={review.granted || review.requested || review.responded}
				variant={review.granted ? "positive" : review.requested ? "warning" : ""}
				disabled={disabled}
				onClick={performReview}
				fullWidth={fullWidth}
			>
				{overrideReview 
				? overrideReview
				: review.granted ? "Approved" : review.responded ? "Responded" : review.requested ? "Requested" : "Request Approval"}
			</Button>
		</SideBarSection>
	);
}

export default ReviewButton;